import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as WarningCircleIcon } from 'assets/icons/warning-circle.svg';
import clsx from 'clsx';

import type IRevenueImpactSection from './interfaces/IRevenueImpactSection';

import styles from './sass/RevenueImpactSection.module.scss';

function RevenueImpactSection({
  customerRevenueImpactPercentage,
  formattedRevenue,
}: IRevenueImpactSection): React.JSX.Element {
  const { t } = useTranslation();
  const hasRevenueImpactPercentage = customerRevenueImpactPercentage !== null;
  const hasRevenueDrop = hasRevenueImpactPercentage && customerRevenueImpactPercentage < 0;
  const revenueArrow = hasRevenueDrop ? '↓' : '↑';
  const formattedRevenueImpactPercentage = hasRevenueImpactPercentage
    ? `${customerRevenueImpactPercentage > 0 ? '+' : ''}${customerRevenueImpactPercentage}% ${revenueArrow}`
    : '—';

  return (
    <section className={styles.tile}>
      <h4 className={styles.tileTitle}>{t('valueChainMap.resultCardRevenueImpact')}</h4>
      <div className={styles.revenueRow}>
        <div className={styles.revenueValue}>{formattedRevenue}</div>
        <span
          className={clsx(styles.revenuePill, {
            [styles.revenuePillDown]: hasRevenueDrop,
          })}
        >
          {formattedRevenueImpactPercentage}
        </span>
      </div>
      <p className={styles.revenueWarning}>
        <WarningCircleIcon className={styles.revenueWarningIcon} aria-hidden="true" />
        <span>{t('valueChainMap.resultCardRevenueAtRisk')}</span>
      </p>
    </section>
  );
}

export default RevenueImpactSection;
